import { render, staticRenderFns } from "./SpecialHeader.vue?vue&type=template&id=2eb41fe0&scoped=true&"
import script from "./SpecialHeader.vue?vue&type=script&lang=ts&"
export * from "./SpecialHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialHeader.vue?vue&type=style&index=0&id=2eb41fe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb41fe0",
  null
  
)

export default component.exports